import { render, staticRenderFns } from "./Procore.vue?vue&type=template&id=58aa31a6&scoped=true"
import script from "./Procore.vue?vue&type=script&lang=js"
export * from "./Procore.vue?vue&type=script&lang=js"
import style0 from "./Procore.vue?vue&type=style&index=0&id=58aa31a6&prod&scoped=true&lang=css"
import style1 from "./Procore.vue?vue&type=style&index=1&id=58aa31a6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58aa31a6",
  null
  
)

export default component.exports